var map = {
	"./facebook.png": 9887,
	"./instagram.png": 9388,
	"./linkedin.png": 86,
	"./tiktok.png": 4168,
	"./twitter.png": 574,
	"./x-logo.png": 4502,
	"./x.png": 4238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7757;